// extracted by mini-css-extract-plugin
export default {"cssTitle":"header_cssTitle__h13v1","cssHomePageTitle":"header_cssHomePageTitle__-o-pz"};